import { Route, Switch, useHistory } from "react-router-dom";

// Screens
import AnalyticsQueue from "screens/Data/AnalyticsQueue/AnalyticsQueue";
import Login from "screens/Login/Login";
import Notifications from "screens/Notifications/Notifications";

// ADA
import CompanyModelView from "screens/AdaViews/CompanyViews/CompanyModelView/CompanyModelView";
import FairValueChartsView from "screens/AdaViews/CompanyViews/FairValueChartsView/FairValueChartsView";
import PortfolioLive from "screens/PortfolioLive/PortfolioLive";
import GEFSectorsView from "./AdaViews/CompanyViews/GEFSectorsView/GEFSectorsView";
import AsiaPlView from "./AdaViews/CompanyViews/AsaiPlView/AsiaPlView";
import NOPATAssumptionsView from "./AdaViews/CompanyViews/NOPATAssumptionsView/NOPATAssumptionsView";
import QualityMatrixView from "./AdaViews/CompanyViews/QualityMatrixView/QualityMatrixView";
import SupplementaryInformationView from "./AdaViews/CompanyViews/SupplementaryInformationView/SupplementaryInformationView";
import TrendsView from "./AdaViews/CompanyViews/TrendsView/TrendsView";
import DummyPortfolio from "./AdaViews/DummyPortfolio/DummyPortfolio";

// Admin
import Permissions from "screens/Admin/Permissions/Permissions";

// Data
import CompanyList from "screens/Data/Companies/CompanyList/CompanyList";
import CompanyManagement from "screens/Data/CompanyManagement/CompanyManagement";
import NewCompaniesPage from "screens/Data/Companies/NewCompanies/NewCompanies";
import StockSplitsPage from "screens/Data/Companies/StockSplits/StockSplits";
import CompanyModelDetail from "screens/Data/CompanyModels/CompanyModelDetail/CompanyModelDetail";
import CompanyModelList from "screens/Data/CompanyModels/CompanyModelList/CompanyModelList";
import DataDictionary from "screens/Data/DataDictionary/DataDictionary";
import DatabaseSchemaPage from "screens/Data/DatabaseSchema/DatabaseSchema";
import ExportBQMQ from "screens/Data/ExportBQMQ/ExportBQMQ";
import DataHome from "screens/Data/Home/Home";
import PortfolioLiveDetail from "screens/Data/PortfolioLive/PortfolioLiveDetail/PortfolioLiveDetail";
import PortfolioLiveList from "screens/Data/PortfolioLive/PortfolioLiveList/PortfolioLiveList";
import SummarySheetDetail from "screens/Data/SummarySheets/SummarySheetDetail/SummarySheetDetail";
import SummarySheetList from "screens/Data/SummarySheets/SummarySheetList/SummarySheetList";
import UploadData from "screens/Data/UploadData/UploadData";
import ValidationRulesPage from "screens/Data/ValidationRules/ValidationRules";

// BQMQ
import CreateSession from "screens/BQMQ/CreateSession/CreateSession";
import BQMQHome from "screens/BQMQ/Home/Home";
import BlankVotingPage from "screens/BQMQ/BlankVotingPage/BlankVotingPage";
import EditSession from "screens/BQMQ/EditSession/EditSession";
import CompanyResultDetail from "screens/BQMQ/Results/CompanyResultDetail/CompanyResultDetail";
import CompanyDetail from "screens/BQMQ/Results/CompanyDetail/CompanyDetail";
import Sessions from "screens/BQMQ/Sessions/Sessions";

// Fees
import ReportsDetail from "components/Screens/Fees/Common/FundTabs/ReportsTab/ReportsDetail/ReportsDetail";
import ScenarioDetail from "components/Screens/Fees/Forecasts/EditScenariosTab/ScenarioDetail/ScenarioDetail";
import DelawareFund from "./Fees/DelawareFund/DelawareFund";
import DublinFund from "./Fees/DublinFund/DublinFund";
import FeesValidationRulesPage from "./Fees/FeesValidationRules/FeesValidationRules";
import FeesForecasts from "./Fees/Forecasts/Forecasts";
import SeparateAccounts from "./Fees/SeparateAccounts/SeparateAccounts";

//NAV
import IncomingFileHistory from "components/Screens/DailyRecs/IncomingFiles/IncomingFileHistory/IncomingFileHistory";

// Reconciliation
import Benchmarks from "./DailyRecs/Checks/Benchmarks/Benchmarks";
import BrokerExposure from "./DailyRecs/Checks/BrokerExposure/BrokerExposure";
import CRNTCashStock from "./DailyRecs/Checks/CRNTCashStock/CRNTCashStock";
import CRNTNav from "./DailyRecs/Checks/CRNTNav/CRNTNav";
import CashflowForecast from "./DailyRecs/Checks/CashflowForecast/CashflowForecast";
import CurrencyExposure from "./DailyRecs/Checks/CurrencyExposure/CurrencyExposure";
import DailyFlowsCheck from "./DailyRecs/Checks/DailyFlowsCheck/DailyFlowsCheck";
import DailyMovements from "./DailyRecs/Checks/DailyMovements/DailyMovements";
import FXRates from "./DailyRecs/Checks/FXRates/FXRates";
import ForwardsNDFExposureEMIR from "./DailyRecs/Checks/ForwardsNDFExposureEMIR/ForwardsNDFExposureEMIR";
import Hedging from "./DailyRecs/Checks/Hedging/Hedging";
import LeverageCollateralFuture from "./DailyRecs/Checks/LeverageCollateralFuture/LeverageCollateralFuture";
import NTVsBBGMarketPrices from "./DailyRecs/Checks/NTVsBBGMarketPrices/NTVsBBGMarketPrices";
import Accruals from "./DailyRecs/Inputs/Accruals/Accruals";
import Configurations from "./DailyRecs/Inputs/Configurations/Configurations";
import DailyFlows from "./DailyRecs/Inputs/DailyFlows/DailyFlows";
import Futures from "./DailyRecs/Inputs/Futures/Futures";
import IncomingFiles from "./DailyRecs/Inputs/IncomingFiles/IncomingFiles";
import OverView from "./DailyRecs/Overviews/Overview/Overview";
import FormPF from "./DailyRecs/Checks/FormPF/FormPF";

//Company
import MorningMeetings from "./Company/MorningMeetings/MorningMeetings";
import MorningMeetingNotes from "./Company/MorningMeetingNotes/MorningMeetingNotes";
import MorningMeetingCompanyNotesDashboard from "./Company/MorningMeetingCompanyNotesDashboard/MorningMeetingCompanyNotesDashboard";
import CompanySummary from "./Company/CompanySummary/CompanySummary";
import EarningsSummary from "./Company/EarningsSummary/EarningsSummary";

//Ask ADA Chat

// GROWTH VOTING
import GrowthDeals from "./GrowthVoting/GrowthDeals/GrowthDeals";
import GrowthHome from "./GrowthVoting/GrowthHome/GrowthHome";
import GrowthCompanies from "./GrowthVoting/GrowthCompanies/GrowthCompanies";

// Components
import HomeRedirect from "components/Common/HomeRedirect/HomeRedirect";
import PrivateRoute from "components/Common/PrivateRoute/PrivateRoute";
import PrivateRenderRoute from "components/Common/PrivateRoute/PrivateRenderRoute";

// Context
import { useSettings } from "context/Settings.context";

// Logger
import Logger from "utils/logger.utils";
import { useAuth } from "../context/Auth.context";
import Docs from "./Docs/Docs";
import Help from "./Help/Help";

// Utils
import { setLastRoute } from "utils/user.utils";
import NewNotes from "./Company/NewNotes/NewNotes";
import OtherNotes from "./Company/OtherNotes/OtherNotes";
import GrowthDealDetail from "./GrowthVoting/GrowthDealDetail/GrowthDealDetail";
import FundMetrics from "./MissionControl/FundMetrics/FundMetrics";
import Tables from "./MissionControl/Tables/Tables";
import ChartsAndAnalysis from "./MissionControl/ChartsAndAnalysis/ChartsAndAnalysis";
import PublicCompanies from "./MissionControl/PublicCompanies/PublicCompanies";
import PrivateCompanyDashboard from "./MissionControl/PrivateCompanyDashboard/PrivateCompanyDashboard";
import PublicCompanyDashboard from "./MissionControl/PublicCompanyDashboard/PublicCompanyDashboard";
import SustainabilityDashboard from "./MissionControl/SustainabilityDashboard/SustainabilityDashboard";
import UsageStatSummary from "./Reporting/UsageStatSummary";

// Constants
import {
    NINETY_DAY_CONSUMPTION_REPORT_ID,
    NINETY_DAY_CONSUMPTION_REPORT_WORKSPACE_ID,
    NINETY_DAY_DASHBOARD_REPORT_ID,
    NINETY_DAY_DASHBOARD_REPORT_WORKSPACE_ID,
    NINETY_DAY_USER_REPORT_ID,
    NINETY_DAY_USER_REPORT_WORKSPACE_ID,
    THIRTY_DAY_REPORT_ID,
    THIRTY_DAY_REPORT_WORKSPACE_ID,
} from "./ScreenConstants";
import MorningMeetingDetails from "./Company/MorningMeetingDetails/MorningMeetingDetails";
import AgendaItemForm from "./Company/AgendaItemForm/AgendaItemForm";
import MorningMeetingTopicClassifierNotesDashboard from "./Company/MorningMeetingTopicClassifierNotesDashboard/MorningMeetingTopicClassifierNotesDashboard";
import GeneratedNotesDashboard from "./Company/GeneratedNotesDashboard/GeneratedNotesDashboard";

const Log = new Logger();
Log.init("MainRoutes");

export default function MainRoutes() {
    const { setRoute } = useSettings();
    const history = useHistory();
    const { user } = useAuth();

    history.listen((location: any) => {
        setRoute(location.pathname);
        if (location.pathname !== "/login" && user) {
            let route = location.pathname + location.search;
            setLastRoute(route, user.id);
        }

        document.getElementById("mainContainer")?.scrollTo(0, 0);
    });

    return (
        <Switch>
            <PrivateRoute
                exact
                path="/"
                permissions={""}
                component={HomeRedirect}
            />

            {/* Portfolio */}
            <PrivateRoute
                exact
                path="/portfolio/snapshot"
                permissions={[
                    "P_bqmq_can_host",
                    "p_bqmq_can_view_results",
                    "p_bqmq_can_vote",
                ]}
                component={PortfolioLive}
            />
            <PrivateRoute
                exact
                path="/portfolio/trends"
                permissions={[
                    "P_bqmq_can_host",
                    "p_bqmq_can_view_results",
                    "p_bqmq_can_vote",
                ]}
                component={TrendsView}
            />
            <PrivateRoute
                exact
                path="/portfolio/supplementary-information"
                permissions={[
                    "P_bqmq_can_host",
                    "p_bqmq_can_view_results",
                    "p_bqmq_can_vote",
                ]}
                component={SupplementaryInformationView}
            />
            <PrivateRoute
                exact
                path="/portfolio/quality-matrix"
                permissions={[
                    "P_bqmq_can_host",
                    "p_bqmq_can_view_results",
                    "p_bqmq_can_vote",
                ]}
                component={QualityMatrixView}
            />
            <PrivateRoute
                exact
                path="/portfolio/gef_sectors"
                permissions={[
                    "P_bqmq_can_host",
                    "p_bqmq_can_view_results",
                    "p_bqmq_can_vote",
                ]}
                component={GEFSectorsView}
            />
            <PrivateRoute
                exact
                path="/portfolio/asia_pl"
                permissions={[
                    "P_bqmq_can_host",
                    "p_bqmq_can_view_results",
                    "p_bqmq_can_vote",
                ]}
                component={AsiaPlView}
            />
            <PrivateRoute
                exact
                path="/portfolio/dummy-portfolio"
                permissions={[
                    "P_bqmq_can_host",
                    "p_bqmq_can_view_results",
                    "p_bqmq_can_vote",
                ]}
                component={DummyPortfolio}
            />
            <PrivateRoute
                exact
                path="/portfolio/morning-meetings"
                permissions={[]}
                component={MorningMeetings}
            />
            <PrivateRoute
                exact
                path="/portfolio/morning-meetings/:id"
                permissions={[]}
                component={MorningMeetingDetails}
            />
            <PrivateRoute
                exact
                path="/portfolio/morning-meetings/:meetingId/agenda-item"
                permissions={[]}
                component={AgendaItemForm}
            />
            <PrivateRoute
                exact
                path="/portfolio/morning-meetings/:meetingId/generated-notes/:notesType"
                permissions={[]}
                component={GeneratedNotesDashboard}
            />

            {/*  DATA  */}
            <PrivateRoute
                exact
                path="/data"
                permissions={["p_list_extractions"]}
                component={DataHome}
            />
            <PrivateRoute
                exact
                path="/data/upload-data"
                permissions={["p_fix_extraction", "p_upload_model"]}
                component={UploadData}
            />
            <PrivateRoute
                exact
                path="/data/company-models"
                permissions={["p_list_extractions"]}
                component={CompanyModelList}
            />
            <PrivateRoute
                exact
                path="/data/company-model"
                permissions={["p_list_extractions"]}
                component={CompanyModelDetail}
            />
            <PrivateRoute
                exact
                path="/data/company-list"
                permissions={["p_update_companies"]}
                component={CompanyList}
            />
            <PrivateRoute
                exact
                path="/data/companies"
                permissions={["p_update_companies"]}
                component={CompanyManagement}
            />
            <PrivateRoute
                exact
                path="/data/new-companies"
                permissions={["p_update_companies"]}
                component={NewCompaniesPage}
            />
            <PrivateRoute
                exact
                path="/data/stock-splits"
                permissions={["p_update_companies"]}
                component={StockSplitsPage}
            />
            <PrivateRoute
                exact
                path="/data/summary-sheets"
                permissions={["p_gbl_dashboard"]}
                component={SummarySheetList}
            />
            <PrivateRoute
                exact
                path="/data/summary-sheet"
                permissions={["p_gbl_dashboard"]}
                component={SummarySheetDetail}
            />
            <PrivateRoute
                exact
                path="/data/portfolio-live-list"
                permissions={["p_gbl_dashboard"]}
                component={PortfolioLiveList}
            />
            <PrivateRoute
                exact
                path="/data/portfolio-live"
                permissions={["p_gbl_dashboard"]}
                component={PortfolioLiveDetail}
            />
            <PrivateRoute
                exact
                path="/data/data-dictionary"
                permissions={["p_view_dictionary"]}
                component={DataDictionary}
            />
            <PrivateRoute
                exact
                path="/data/database-schema"
                permissions={["p_view_dictionary"]}
                component={DatabaseSchemaPage}
            />
            <PrivateRoute
                exact
                path="/data/validation-rules"
                permissions={["p_update_validation"]}
                component={ValidationRulesPage}
            />
            <PrivateRoute
                exact
                path="/data/analytics-queue"
                permissions={["p_fix_extraction", "p_upload_model"]}
                component={AnalyticsQueue}
            />
            <PrivateRoute
                exact
                path="/data/export-bqmq"
                permissions={["p_bqmq_can_export"]}
                component={ExportBQMQ}
            />

            {/* FEES */}
            <PrivateRoute
                exact
                path="/fees/forecasts"
                permissions={["p_can_action_fees", "p_can_view_fees"]}
                component={FeesForecasts}
            />

            <PrivateRoute
                exact
                path="/fees/forecasts/scenario"
                permissions={["p_can_view_fees", "p_can_action_fees"]}
                component={ScenarioDetail}
            />

            <PrivateRoute
                exact
                path="/fees/dublin/report"
                permissions={["p_can_action_fees", "p_can_view_fees"]}
                component={ReportsDetail}
            />

            <PrivateRoute
                exact
                path="/fees/delaware/report"
                permissions={["p_can_action_fees", "p_can_view_fees"]}
                component={ReportsDetail}
            />

            <PrivateRoute
                exact
                path="/fees/dublin"
                permissions={["p_can_action_fees", "p_can_view_fees"]}
                component={DublinFund}
            />

            <PrivateRoute
                exact
                path="/fees/delaware"
                permissions={["p_can_action_fees", "p_can_view_fees"]}
                component={DelawareFund}
            />

            <PrivateRoute
                exact
                path="/fees/separate-accounts"
                permissions={["p_can_action_fees", "p_can_view_fees"]}
                component={SeparateAccounts}
            />

            <PrivateRoute
                exact
                path="/fees/validation-rules"
                permissions={["p_can_action_fees", "p_can_view_fees"]}
                component={FeesValidationRulesPage}
            />

            {/* DAILY NAVS */}
            {/* INPUTS */}
            <PrivateRoute
                exact
                path="/reconciliation/inputs/incoming_files"
                permissions={["p_can_view_navs"]}
                component={IncomingFiles}
            />

            <PrivateRoute
                exact
                path="/reconciliation/inputs/incoming_file_history"
                permissions={["p_can_view_navs"]}
                component={IncomingFileHistory}
            />

            <PrivateRoute
                exact
                path="/reconciliation/inputs/daily_flows"
                permissions={["p_can_view_navs"]}
                component={DailyFlows}
            />

            <PrivateRoute
                exact
                path="/reconciliation/inputs/configurations"
                permissions={["p_can_view_navs"]}
                component={Configurations}
            />

            <PrivateRoute
                exact
                path="/reconciliation/inputs/accruals"
                permissions={["p_can_view_navs"]}
                component={Accruals}
            />

            <PrivateRoute
                exact
                path="/reconciliation/inputs/futures_credit_rating"
                permissions={["p_can_view_navs"]}
                component={Futures}
            />

            {/* DAILY NAVS */}
            {/* OVERVIEW */}
            <PrivateRoute
                exact
                path="/reconciliation/overviews/checks"
                permissions={["p_can_view_navs"]}
                component={OverView}
            />

            {/* DAILY NAVS */}
            {/* CHECKS */}
            <PrivateRoute
                exact
                path="/reconciliation/checks/daily_flows"
                permissions={["p_can_view_navs"]}
                component={DailyFlowsCheck}
            />

            <PrivateRoute
                exact
                path="/reconciliation/checks/cashflow_forecast"
                permissions={["p_can_view_navs"]}
                component={CashflowForecast}
            />

            <PrivateRoute
                exact
                path="/reconciliation/checks/daily_movements"
                permissions={["p_can_view_navs"]}
                component={DailyMovements}
            />

            <PrivateRoute
                exact
                path="/reconciliation/checks/form_pf"
                permissions={["p_can_view_navs"]}
                component={FormPF}
            />

            <PrivateRoute
                exact
                path="/reconciliation/checks/fx_rates"
                permissions={["p_can_view_navs"]}
                component={FXRates}
            />

            <PrivateRoute
                exact
                path="/reconciliation/checks/benchmarks"
                permissions={["p_can_view_navs"]}
                component={Benchmarks}
            />

            <PrivateRoute
                exact
                path="/reconciliation/checks/cr_nt_nav"
                permissions={["p_can_view_navs"]}
                component={CRNTNav}
            />

            <PrivateRoute
                exact
                path="/reconciliation/checks/cr_ntcash_stock"
                permissions={["p_can_view_navs"]}
                component={CRNTCashStock}
            />

            <PrivateRoute
                exact
                path="/reconciliation/checks/hedging"
                permissions={["p_can_view_navs"]}
                component={Hedging}
            />

            <PrivateRoute
                exact
                path="/reconciliation/checks/currency_exposure_checks"
                permissions={["p_can_view_navs"]}
                component={CurrencyExposure}
            />

            <PrivateRoute
                exact
                path="/reconciliation/checks/forwards_ndfexposure_emir"
                permissions={["p_can_view_navs"]}
                component={ForwardsNDFExposureEMIR}
            />

            <PrivateRoute
                exact
                path="/reconciliation/checks/broker_exposure"
                permissions={["p_can_view_navs"]}
                component={BrokerExposure}
            />

            <PrivateRoute
                exact
                path="/reconciliation/checks/leverage_collateral_future"
                permissions={["p_can_view_navs"]}
                component={LeverageCollateralFuture}
            />

            <PrivateRoute
                exact
                path="/reconciliation/checks/nt-vs-bbg-market-prices"
                permissions={["p_can_view_navs"]}
                component={NTVsBBGMarketPrices}
            />

            {/* GROWTH VOTING */}
            <PrivateRoute
                exact
                path="/growth-voting"
                permissions={["p_can_view_growth_voting"]}
                component={GrowthHome}
            />
            <PrivateRoute
                exact
                path="/growth-voting/deals"
                permissions={["p_can_view_growth_voting"]}
                component={GrowthDeals}
            />
            <PrivateRoute
                exact
                path="/growth-voting/deals/:id"
                permissions={["p_can_view_growth_voting"]}
                component={GrowthDealDetail}
            />
            <PrivateRoute
                exact
                path="/growth-voting/companies"
                permissions={["p_can_view_growth_voting"]}
                component={GrowthCompanies}
            />

            {/* COMPANY */}
            <PrivateRoute
                exact
                path="/company/company-summary"
                permissions={[]}
                component={CompanySummary}
            />
            <PrivateRoute
                exact
                path="/company/earnings-summary"
                permissions={[]}
                component={EarningsSummary}
            />
            <PrivateRoute
                exact
                path="/company/company-summary/:company_id"
                permissions={[]}
                component={CompanySummary}
            />
            <PrivateRoute
                exact
                path="/company/voting"
                permissions={["p_bqmq_can_vote", "p_bqmq_can_view_results"]}
                component={BQMQHome}
            />
            <PrivateRoute
                exact
                path="/company/voting/sessions"
                permissions={["p_bqmq_can_vote", "p_bqmq_can_view_results"]}
                component={Sessions}
            />
            <PrivateRoute
                exact
                path="/company/voting/create-session"
                permissions={["p_bqmq_can_create_session", "p_bqmq_can_host"]}
                component={CreateSession}
            />
            <PrivateRoute
                exact
                path="/company/voting/vote"
                permissions={["p_bqmq_can_vote"]}
                component={BlankVotingPage}
            />
            <PrivateRoute
                exact
                path="/company/voting/edit-session"
                permissions={[
                    "p_bqmq_can_edit_session",
                    "p_bqmq_vote_edit_super_user",
                ]}
                component={EditSession}
            />
            <PrivateRoute
                exact
                path="/company/voting/result/company"
                permissions={["p_bqmq_can_view_results"]}
                component={CompanyResultDetail}
            />
            <PrivateRoute
                exact
                path="/company/voting/company"
                permissions={["p_bqmq_can_view_results"]}
                component={CompanyDetail}
            />
            <PrivateRoute
                exact
                path="/company/fair-value-charts"
                permissions={[
                    "P_bqmq_can_host",
                    "p_bqmq_can_view_results",
                    "p_bqmq_can_vote",
                ]}
                component={FairValueChartsView}
            />
            <PrivateRoute
                exact
                path="/company/financials"
                permissions={[
                    "P_bqmq_can_host",
                    "p_bqmq_can_view_results",
                    "p_bqmq_can_vote",
                ]}
                component={CompanyModelView}
            />
            <PrivateRoute
                exact
                path="/company/nopat_assumptions"
                permissions={[
                    "P_bqmq_can_host",
                    "p_bqmq_can_view_results",
                    "p_bqmq_can_vote",
                ]}
                component={NOPATAssumptionsView}
            />
            <PrivateRoute
                exact
                path="/company/morning-meeting-notes"
                permissions={[]}
                component={MorningMeetingNotes}
            />
            <PrivateRoute
                exact
                path="/company/morning-meeting-company-notes"
                permissions={[]}
                component={MorningMeetingCompanyNotesDashboard}
            />
            <PrivateRoute
                exact
                path="/company/morning-meeting-topic-classifier-notes"
                permissions={[]}
                component={MorningMeetingTopicClassifierNotesDashboard}
            />
            <PrivateRoute
                exact
                path="/company/new-notes"
                permissions={[]}
                component={NewNotes}
            />
            <PrivateRoute
                exact
                path="/company/other-notes"
                permissions={[]}
                component={OtherNotes}
            />

            {/*   MISSION CONTROL   */}
            <PrivateRoute
                exact
                path="/mission-control/fund-metrics"
                permissions={["p_can_view_mission_control"]}
                component={FundMetrics}
            />

            <PrivateRoute
                exact
                path="/mission-control/tables"
                permissions={["p_can_view_mission_control"]}
                component={Tables}
            />

            <PrivateRoute
                exact
                path="/mission-control/charts-and-analysis"
                permissions={["p_can_view_mission_control"]}
                component={ChartsAndAnalysis}
            />

            <PrivateRoute
                exact
                path="/mission-control/public-companies"
                permissions={["p_can_view_mission_control_public"]}
                component={PublicCompanies}
            />

            <PrivateRoute
                exact
                path="/mission-control/private-company-dashboard"
                permissions={["p_can_view_mission_control"]}
                component={PrivateCompanyDashboard}
            />

            <PrivateRoute
                exact
                path="/mission-control/public-company-dashboard"
                permissions={["p_can_view_mission_control_public"]}
                component={PublicCompanyDashboard}
            />

            <PrivateRoute
                exact
                path="/mission-control/sustainabilities-dashboard"
                permissions={["p_can_view_mission_control"]}
                component={SustainabilityDashboard}
            />

            <PrivateRenderRoute
                exact
                path="/reporting/thirty-day-summary"
                permissions={["p_can_view_reporting"]}
                render={(props) => (
                    <UsageStatSummary
                        {...props}
                        workspaceId={THIRTY_DAY_REPORT_WORKSPACE_ID}
                        reportId={THIRTY_DAY_REPORT_ID}
                    />
                )}
            />

            <PrivateRenderRoute
                exact
                path="/reporting/ninety-day-dashboard-summary"
                permissions={["p_can_view_reporting"]}
                render={(props) => (
                    <UsageStatSummary
                        {...props}
                        workspaceId={NINETY_DAY_DASHBOARD_REPORT_WORKSPACE_ID}
                        reportId={NINETY_DAY_DASHBOARD_REPORT_ID}
                    />
                )}
            />

            <PrivateRenderRoute
                exact
                path="/reporting/ninety-day-user-summary"
                permissions={["p_can_view_reporting"]}
                render={(props) => (
                    <UsageStatSummary
                        {...props}
                        workspaceId={NINETY_DAY_USER_REPORT_WORKSPACE_ID}
                        reportId={NINETY_DAY_USER_REPORT_ID}
                    />
                )}
            />

            <PrivateRenderRoute
                exact
                path="/reporting/ninety-day-consumption-summary"
                permissions={["p_can_view_reporting"]}
                render={(props) => (
                    <UsageStatSummary
                        {...props}
                        workspaceId={NINETY_DAY_CONSUMPTION_REPORT_WORKSPACE_ID}
                        reportId={NINETY_DAY_CONSUMPTION_REPORT_ID}
                    />
                )}
            />

            {/*   ADMIN   */}
            <PrivateRoute
                exact
                path="/admin/permissions"
                permissions={["s_update_permissions"]}
                component={Permissions}
            />

            {/*   NOTIFICATIONS   */}
            <PrivateRoute
                exact
                path="/notifications"
                permissions={["p_read_own_notification_web"]}
                component={Notifications}
            />

            {/*  DOCS   */}
            <PrivateRoute
                exact={false}
                path="/docs"
                permissions="p_can_view_docs"
                component={Docs}
            />

            {/*  HELP   */}
            <PrivateRoute
                exact={false}
                path="/help"
                permissions="p_can_view_help"
                component={Help}
            />

            <Route path="/login" component={Login} />
        </Switch>
    );
}
